import { makeObservable } from "@faire/web/common/makeObservable";
import { singletonGetter } from "@faire/web/common/singletons/getter";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import Viewport from "@faire/web/common/Viewport";
import { createStoreHook } from "@faire/web/ui/hooks/useStore";
import { action, computed, observable } from "mobx";

import { MarketStore } from "../domain/Events/FaireMarkets/MarketStore";

/**
 * @chriskrogh will be cleaning this store up soon
 * @deprecated prefer to use `useTopOfPageContentStore` or `withStores` instead
 */
export class TopOfPageContentStore {
  constructor() {
    makeObservable(this);
  }

  @observable
  private height = 0;

  @observable
  private shouldKeepTopNavVisible = false;

  @observable
  private _promoBannerHeight = 0;

  setPromoBannerHeight = (height: number) => {
    this._promoBannerHeight = height;
  };

  @observable
  private _promoBannerVisibleHeight = 0;

  setPromoBannerVisibleHeight = (height: number) => {
    this._promoBannerVisibleHeight = height;
  };

  /**
   * @trackfunction
   */
  static get = singletonGetter(TopOfPageContentStore);

  @action
  setHeaderHeight = (height: number | undefined) => {
    if (isNotUndefined(height)) {
      this.height = height;
    }
  };

  @action
  setShouldKeepTopNavVisible = (newValue: boolean) => {
    this.shouldKeepTopNavVisible = newValue;
  };

  @computed
  get getShouldKeepTopNavVisible() {
    return this.shouldKeepTopNavVisible;
  }

  @computed
  get promoBannerHeight(): number {
    if (
      MarketStore.get().isShowingCountdownBanner &&
      Viewport.getDefault().isDesktopAndAbove
    ) {
      return this._promoBannerHeight;
    }
    return this._promoBannerVisibleHeight;
  }

  @computed
  get headerHeight() {
    return this.height;
  }

  @computed
  get headerPlusPromoBannerHeight() {
    return this.promoBannerHeight + this.headerHeight;
  }

  @computed
  get heightWithHeaderOrMarketBanner() {
    return MarketStore.get().isShowingCountdownBanner &&
      Viewport.getDefault().isDesktopAndAbove
      ? this.promoBannerHeight
      : this.headerHeight;
  }

  @computed
  get heightWithoutPromoBannerExceptMarket() {
    return MarketStore.get().isShowingCountdownBanner &&
      Viewport.getDefault().isDesktopAndAbove
      ? this.headerPlusPromoBannerHeight
      : this.headerHeight;
  }
}

export const useTopOfPageContentStore = createStoreHook(TopOfPageContentStore);
